import { Grid, makeStyles, Typography } from "@material-ui/core";
import { InfoBox } from "../../../../components/boxes/InfoBox";
import { COLORS } from "../../../../theme/colors";
import { Box } from "../Box";
import { GroupButton } from "../GroupButton";
import { Header } from "../Header";

const useStyles = makeStyles((theme) => ({
  eventTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  boldText: {
    fontWeight: 600,
    display: "inline",
  },
}));

export const MaintenanceAlert = ({ building, onClose }) => {
  const classes = useStyles();

  return (
    <Box>
      <Header title="Maintenance Alert" building={building} onClose={onClose} />

      <InfoBox color="#FFE6E6">
        <Typography variant="h4" style={{ color: COLORS.red }}>
          Elevator inspection - 5 days delay
        </Typography>
      </InfoBox>

      <Typography className={classes.eventTitle}>
        Elevator routine maintenance
      </Typography>
      <Grid container>
        <Grid item xs={7}>
          <Typography className={classes.boldText}>Last inspection:</Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.boldText}>Nov 30, 2021</Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={7}>
          <Typography className={classes.boldText}>
            Next inspection was scheduled for:
          </Typography>
        </Grid>
        <Grid item>
          <Typography className={classes.boldText}>
            Feb 1, 2022 -{" "}
            <Typography
              className={classes.boldText}
              style={{ color: COLORS.red }}
            >
              5 days delay
            </Typography>
          </Typography>
        </Grid>
      </Grid>

      <GroupButton
        buttons={[
          { text: "SHARE" },
          { text: "VIEW REPORT" },
          { text: "EXPORT SAME TYPE ALERTS " },
        ]}
      />
    </Box>
  );
};
